import React from "react"
import styled, { css } from "styled-components"

import ImageContentful from "./ImageContentful"

import { media, mixins } from "../styles"

const IconContainer = styled.div`
  display: flex;
  width: 100%;

  @media ${media.md} {
    margin-bottom: 10px;
  }

  ${(props) =>
    props.$layout === "icon-left" &&
    css`
      @media ${media.md} {
        margin: 0;
        padding-right: 20px;
        width: 16.66666667%;
      }
    `}
`

export const Icon = styled.div`
  height: 48px;
  width: 48px;
  margin: 0 auto 10px;

  @media ${media.md} {
    height: 40px;
    margin: 0 auto;
    width: 40px;
  }

  @media ${media.lg} {
    margin: 0 0 5px;
  }

  @media ${media.xl} {
    height: 48px;
    width: 48px;
  }

  img {
    height: auto;
    width: 100%;
  }

  ${(props) =>
    props.$layout === "compact" &&
    css`
      && {
        height: 24px;
        width: 24px;
      }
    `}

  ${(props) =>
    props.$layout === "icon-left" &&
    css`
      @media ${media.md} {
        margin: 0 0 0 auto;
      }

      @media ${media.xl} {
        margin: 0 auto;
      }
    `}

    ${(props) =>
    props.$layout === "illustration-round" &&
    css`
      height: 180px;
      width: 180px;

      @media ${media.md} {
        margin: 0 auto 10px;
        height: 180px;
        width: 180px;
      }
    `}
`

export const Text = styled.div`
  width: 100%;

  ${(props) =>
    props.$layout === "icon-left" &&
    css`
      @media ${media.md} {
        width: 83.33333333%;
      }
    `}

  ${(props) =>
    props.$layout === "illustration-round" &&
    css`
      @media ${media.md} {
        margin: 0 auto;
        text-align: center;
        width: 83.33333333%;
      }
    `}
`

export const IconWithTextContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  margin: 0 0 40px;
  text-align: center;

  h3 {
    ${mixins.title6}
    margin-bottom: 5px;
  }

  p {
    ${mixins.copy4}
    margin: 0;
  }

  @media ${media.md} {
    flex-direction: column;
    margin-bottom: 40px;
    padding: 0 30px;
    text-align: center;
  }

  @media ${media.lg} {
    padding: 0 40px 0 0;
    text-align: left;
  }

  @media ${media.xl} {
    padding: 0 50px 0 0;
    margin-bottom: 90px;
  }

  ${(props) =>
    props.$layout === "compact" &&
    css`
      && {
        margin-bottom: 30px;
      }
    `}

  ${(props) =>
    props.$layout === "icon-left" &&
    css`
      h3 {
        ${mixins.title6}

        @media ${media.md} {
          margin-bottom: 0px;
        }
      }

      p {
        ${mixins.copy5}
      }

      @media ${media.md} {
        flex-direction: row;
        text-align: left;
        padding: 0;
        margin: 0 0 30px;
        width: 100%;
      }

      @media ${media.xl} {
        margin: 0 0 50px;
      }
    `}

  ${(props) =>
    props.$layout === "illustration-round" &&
    css`
      @media ${media.md} {
        padding: 0 30px;
      }

      @media ${media.lg} {
        padding: 0 20px;
      }

      @media ${media.xl} {
        padding: 0 25px;
      }
    `}
`

const IconWithText = (props) => {
  const { title, icon, text, className, layout } = props

  return (
    <IconWithTextContainer
      className={`${className || ""} icon-with-text`}
      $layout={layout}
    >
      {icon && (
        <IconContainer aria-hidden="true" $layout={layout}>
          <Icon $layout={layout}>
            <ImageContentful image={icon} alt="" inline />
          </Icon>
        </IconContainer>
      )}
      <Text $layout={layout}>
        {title && <h3>{title}</h3>}
        {text && (
          <span
            dangerouslySetInnerHTML={{
              __html: text,
            }}
          />
        )}
      </Text>
    </IconWithTextContainer>
  )
}

export default IconWithText
